import { SocialBlock } from './SocialBlock';
import { signInActions } from './actions';

export const SocialSignInBlock = ({redirect}: {redirect?: string}) => {
  return <SocialBlock actions={signInActions} redirect={redirect} />;
};
